import { createFileRoute } from "@tanstack/react-router";
import { WorkspaceSettingsNavigation } from "@/components/settings/workspace-settings-navigation";

export const Route = createFileRoute("/$owner/settings/")({
	component: SettingsIndex,
});

function SettingsIndex() {
	const { owner } = Route.useParams();
	return <WorkspaceSettingsNavigation owner={owner} />;
}
